import {useCallback, useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router";
import {createTheme, CssBaseline, ThemeProvider} from "@mui/material";
import {AdminPanelSettings, AttachMoney, CompareArrows, Delete, DoneAll, History, ListAlt, MilitaryTech, QueryStats, Stadium, StadiumOutlined, WorkHistory} from "@mui/icons-material";
import {AppHeader} from "../components/AppHeader";
import {AppFooter} from "../components/AppFooter";
import {NavigationDrawer} from "../components/NavigationDrawer";
import {apiGet, isLoggedIn} from "../utils";

//TODO: update theme and use it everywhere...
const theme = createTheme({
    palette: {
        background: {
            default: '#EFF0F475'
        },
        primary: {
            main: '#041C2C'
        },
        secondary: {
            main: '#FA4616'
        },
        warning: {
            main: '#FF0000'
        },
        contentPanel: {
            backgroundColor: 'white',
            border: 'thin solid #041C2C25',
            borderRadius: 7,
            boxShadow: '1px 1px #041C2C50'
        },
        indicator: {
            red: '#E51040',
            orange: '#FFA500',
            green: '#308830',
            blue: '#000099',
            plot: {
                green: {
                    line: '#00770050',
                    fill: '#00FF0025'
                },
                blue: {
                    line: '#00009950',
                    fill: '#00009925'
                },
                bubble: {
                    blue: '#00009975',
                    red: '#99000475',
                    yellow: '#99990075',
                    green: '#00994C75'
                }
            },
            table: {
                red: '#FF000085',
                green: '#00660085',
                blue: '#00009985',
            }
        }
    },
    dimensions: {
        headerHeight: 55,
        footerHeight: 40,
        navDrawerWidth: 180,
        contentWidth: 1550,
        smallPanelWidth: 460
    }
});

//TODO: add a Rules page... or link to doc...?
const navOptions = [
    {id: 1, label: 'Rosters', icon: <ListAlt/>, to: '/rosters', isHome: true},
    {id: 2, label: 'Auction', icon: <AttachMoney/>, to: '/auction'},
    {id: 3, label: 'Trade', icon: <CompareArrows/>, to: '/trade'}, //, phases: ['NEW', 'PREDRAFT', 'SEASON', 'POSTSEASON']},
    {id: 4, label: 'Drop', icon: <Delete/>, to: '/drop'},
    {id: 5, divider: true},
    {id: 6, label: 'Pre-Draft', icon: <StadiumOutlined/>, to: '/predraft', phases: ['PREDRAFT']},
    {id: 7, label: 'Draft', icon: <Stadium/>, to: '/draft'},
    {id: 8, label: 'Draft Trade', icon: <CompareArrows/>, to: '/drafttrade', phases: ['PREDRAFT', 'DRAFT'], adminOnly: true},
    {id: 9, divider: true},
    {id: 10, label: 'History', icon: <History/>, to: '/history'},
    {id: 11, label: 'Records', icon: <MilitaryTech/>, to: '/records'},
    {id: 12, label: 'Stats', icon: <QueryStats/>, to: '/stats'},
    {id: 13, label: 'Activity', icon: <WorkHistory/>, to: '/activity'},
    {id: 14, divider: true},
    {id: 15, label: 'Wins', icon: <DoneAll/>, to: '/wins'},
    {id: 16, divider: true},
    {id: 17, label: 'Admin', icon: <AdminPanelSettings/>, to: '/admin', adminOnly: true},
    {id: 18, label: 'Audit', icon: <AdminPanelSettings/>, to: '/audit', adminOnly: true}
];

export const AppLayout = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [shouldRender, setShouldRender] = useState(false);
    const [currentNavOption, setCurrentNavOption] = useState(navOptions.find(o => o.to === location.pathname));
    const [currentLeague, setCurrentLeague] = useState({});
    const [currentSeason, setCurrentSeason] = useState({});
    const [currentAuction, setCurrentAuction] = useState({});

    const fetchCurrentLeague = () => {
        apiGet(`league/current`, (data) => {
            setCurrentLeague(data.data ? data.data : {});
        });
    };

    const fetchCurrentSeason = () => {
        apiGet(`season/current`, (data) => {
            setCurrentSeason(data.data ? data.data : {});
        });
    };

    const fetchCurrentAuction = () => {
        apiGet(`auction/current`, (data) => {
            setCurrentAuction(data.data ? data.data : {});
        });
    };

    const refreshLeagueMetadata = useCallback(() => {
        fetchCurrentLeague();
        fetchCurrentSeason();
        fetchCurrentAuction();
    }, []);

    useEffect(() => {
        refreshLeagueMetadata();
    }, [refreshLeagueMetadata]);

    useEffect(() => {
        if (isLoggedIn()) {
            setShouldRender(true);
        } else {
            navigate('/');
        }
    }, [navigate]);

    const handleNavigate = (toNavOption) => {
        setCurrentNavOption(toNavOption);
        navigate(toNavOption.to);
    };

    const handleNavigateToHome = () => {
        handleNavigate(navOptions.find(o => o.isHome));
    };

    const handleNavigateToAlerts = () => {
        setCurrentNavOption(null);
        navigate('/alerts');
    };

    const handleNavigateToSettings = () => {
        setCurrentNavOption(null);
        navigate('/settings');
    };

    return (
        shouldRender ?
            <div>
                <ThemeProvider theme={theme}>
                    <CssBaseline/>
                    <AppHeader handleNavigateToHome={handleNavigateToHome} handleNavigateToAlerts={handleNavigateToAlerts} handleNavigateToSettings={handleNavigateToSettings}/>
                    <NavigationDrawer navOptions={navOptions} currentNavOption={currentNavOption} handleNavigate={handleNavigate}
                                      currentLeague={currentLeague} currentSeason={currentSeason} currentAuction={currentAuction}
                                      refreshLeagueMetadata={refreshLeagueMetadata}/>
                    <AppFooter/>
                </ThemeProvider>
            </div>
            :
            <div/>
    );
};
